/**
 * P&L privacy masking — the display-layer primitive behind the eye toggle
 * (displaySettings.showPnl, shared with Position Tracker; #124).
 *
 * When a trader hides P&L, every economic dollar value AND any sign-revealing
 * derived figure (e.g. a signed ROI%) must render as a neutral placeholder and
 * drop its green/red tint, so neither the amount nor the up/down sign leaks.
 * Per-contract prices (market odds) are NOT P&L and stay visible — callers
 * simply don't route those through here.
 *
 * Formatter-agnostic on purpose: it takes an already-formatted string so it
 * composes with every money formatter on the page (plain dollars, signed
 * dollars, percent) without knowing their shapes. Kept as a shared module so
 * My Trades and the shared TradeCard mask identically; other surfaces
 * (Position Tracker, OrgTradersTable) keep their own inline copies for now.
 */

export const PNL_MASK = '•••';

/** The formatted value, or the mask when P&L is hidden. Wrap the WHOLE
 *  formatted expression (including any `—` it produces for missing data): a
 *  hidden slot always reads `•••`, so "no data" can't be distinguished from a
 *  real value while hidden. */
export function maskPnl(hide: boolean, formatted: string): string {
  return hide ? PNL_MASK : formatted;
}

/** A sign-revealing color class, neutralized while hidden so red/green can't
 *  leak the P&L sign. Returns `neutral` when hidden, else the given class. */
export function maskPnlColor(
  hide: boolean,
  colorClass: string,
  neutral = 'text-muted-foreground',
): string {
  return hide ? neutral : colorClass;
}
